import _DatabaseModel from "./_DatabaseModel";

class Snippet extends _DatabaseModel {
  static model = "snippet";
  static editDialogComponent = "snippets-edit-dialog";

  static tableHeaders = [{ textKey: "form.label.name", value: "name" }];

  static show = {
    buttons: ["edit"],
    reloadingModels: [],
  };

  static filter = {
    parts: {
      fields: ["name", "time_filter"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static cardFields(object) {
    return {
      title: object.name,
    };
  }

  static submenuActions = [
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static basicInfo(object) {
    return [
      {
        labelKey: "team.team",
        value: object.team,
        type: "link",
        to: "teams",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static tabs = [this.detailTab];
}

export default Snippet;
